import { Users } from "lucide-react"

import { cn } from "@vc/lib/utils"

/**
 * Which room you are in, said plainly at the top of the stage.
 *
 * Once breakout rooms are running, a meeting is several rooms that look
 * identical: the same grid of faces, with no way to tell the main room from
 * Room 2 except by recognising who is in it. This names it. Shown to everyone —
 * a moderator moving between rooms needs it as much as anyone, arguably more.
 *
 * Silent while there are no breakout rooms, when there is only one room to be
 * in and a badge saying so would be furniture.
 */
export function RoomNameBadge({
  roomName,
  /** Pushed down when the broadcast indicator already holds the top centre. */
  offset = false,
  className,
}: {
  roomName: string | null
  offset?: boolean
  className?: string
}) {
  if (!roomName) return null

  return (
    <div
      className={cn(
        "fixed left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-1.5",
        "rounded-full shadow-lg bg-vc-surface-elevated/90 backdrop-blur-sm ring-1 ring-white/15",
        offset ? "top-16" : "top-4",
        className,
      )}
    >
      <Users className="h-3.5 w-3.5 text-white/70" />
      <span className="text-sm font-medium text-white">{roomName}</span>
    </div>
  )
}
